module.exports = __webpack_public_path__ + "static/img/map.3f94f06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/map.png
// module id = tK2t
// module chunks = 49